import React, { useEffect, useRef } from 'react';

import { formatFigure } from 'Helpers/formatService';

import EditIcon from 'Assets/icons/edit.svg';
import TrashIcon from 'Assets/icons/trash.svg';

export default function GeneralOpportunitiesTable({ isLoading, opportunities, canEdit, canDelete, onEdit, onDelete }) {
    const opportunitiesListRef = useRef();

    useEffect(() => {
        if (opportunitiesListRef.current) {
            opportunitiesListRef.current.scrollTop = opportunitiesListRef.current.scrollHeight;
        }
    }, [opportunities.length]);

    return (
        <div className="inbud-table_wrapper" ref={opportunitiesListRef}>
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th className="tw-sticky tw-left-0 tw-bg-gray-100 tw-min-w-64 tw-max-w-64 tw-z-10">{$t('Department')}</th>
                        <th className="tw-min-w-64 tw-max-w-64">{$t('Name')}</th>
                        <th className="tw-min-w-96">{$t('Description')}</th>
                        <th className="tw-min-w-32 tw-max-w-32">{$t('Amount')}</th>
                        <th className="tw-min-w-32 tw-max-w-32">{$t('AFC')}</th>
                        <th className="tw-min-w-64 tw-max-w-64">{$t('Budget Line')}</th>
                        <th className="tw-min-w-28 tw-max-w-28">{$t('Actions')}</th>
                    </tr>
                </thead>
                {!isLoading && !!opportunities?.length && (
                    <tbody>
                        {opportunities.map((opportunity, index) => (
                            <GeneralOpportunityRow
                                key={opportunity.id}
                                opportunity={opportunity}
                                onEdit={onEdit}
                                canEdit={canEdit}
                                canDelete={canDelete}
                                onDelete={onDelete}
                            />
                        ))}
                    </tbody>
                )}
                {isLoading && (
                    <tbody>
                        <tr>
                            <td colSpan={7}>{$t('Loading')}...</td>
                        </tr>
                    </tbody>
                )}
                {!isLoading && !opportunities?.length && (
                    <tbody>
                        <tr>
                            <td colSpan={7}>
                                <span className="tw-italic">{$t('No Opportunities found')}</span>
                            </td>
                        </tr>
                    </tbody>
                )}
            </table>
        </div>
    );
}

function GeneralOpportunityRow({ opportunity, canEdit, canDelete, onEdit, onDelete }) {
    return (
        <tr>
            <td className="tw-sticky tw-left-0 tw-bg-gray-100">{opportunity.department_name}</td>
            <td>{opportunity.name}</td>
            <td>{opportunity.description}</td>
            <td className="inbud-numeric-cell">{formatFigure(opportunity.amount)}</td>
            <td>{opportunity.afc ? $t('Yes') : $t('No')}</td>
            <td>{opportunity.budget_line_name}</td>
            <td>
                <div className="tw-flex tw-items-center tw-gap-x-3">
                    {!!canEdit && (
                        <button type="button" onClick={() => onEdit(opportunity)}>
                            <EditIcon className="tw-w-3 tw-h-3" />
                        </button>
                    )}
                    {!!canDelete && (
                        <button type="button" className="tw-text-red" onClick={() => onDelete(opportunity)}>
                            <TrashIcon className="tw-w-3 tw-h-3" />
                        </button>
                    )}
                </div>
            </td>
        </tr>
    );
}
